import React from 'react';
import Icon from 'shared/components/icon';
import 'stylesheets/components/college-success/empty-state.scss';

const EmptyState = () => (
  <div className="shared-carousel college-success-carousel-empty-state">
    <Icon iconType="star" className="college-success-carousel-empty-state-icon" />
    <Icon iconType="star" className="college-success-carousel-empty-state-icon" />
    <Icon iconType="star" className="college-success-carousel-empty-state-icon" />
    <p className="college-success-carousel-empty-state-text">
      Congratulations! You have completed all the college success tasks!
    </p>
  </div>
);

export default EmptyState;
